import { motion } from "framer-motion";
import { Reveal, MaskLine } from "@/components/Reveal";
import { PROCESS } from "@/data/site";

export const Process = () => (
  <section id="process" data-testid="process" className="relative py-32 sm:py-44 border-t border-white/5">
    <div className="max-w-screen-2xl mx-auto px-6 sm:px-10">
      <Reveal><p className="label mb-6">Prozess</p></Reveal>
      <h2 className="font-serif font-light text-4xl sm:text-6xl lg:text-7xl tracking-tight uppercase mb-20">
        <MaskLine>Fünf Schritte.</MaskLine>
        <MaskLine delay={0.08} className="text-[#d4c4a8] italic">Ein Ergebnis.</MaskLine>
      </h2>

      <div className="divide-y divide-white/5 border-y border-white/5">
        {PROCESS.map((p, i) => (
          <motion.div
            key={p.n}
            data-testid={`process-${p.n}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
            className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-10 md:py-12 items-baseline hover:bg-[#0c0c0c] transition-colors duration-500"
          >
            <span className="md:col-span-2 font-serif text-5xl sm:text-6xl text-[#2a2a2a] group-hover:text-[#d4c4a8] transition-colors duration-500">{p.n}</span>
            <h3 className="md:col-span-4 font-display uppercase tracking-[0.18em] text-xl sm:text-2xl text-[#fafafa]">{p.t}</h3>
            <p className="md:col-span-6 font-body text-[#a1a1aa] leading-relaxed">{p.d}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
